// action types
import { createRequestTypes } from "../../utils";

export const FETCH_ARTICLE = createRequestTypes("FETCH_ARTICLE");

export const fetchArticleRequest = (slug) =>
    ({ type: FETCH_ARTICLE.REQUEST, payload: slug });

export const fetchArticleSuccess = (article) =>
    ({ type: FETCH_ARTICLE.SUCCESS, payload: article });

export const fetchArticleFailure = (error) =>
    ({ type: FETCH_ARTICLE.FAILURE, payload: { error } });